import { createFileRoute } from '@tanstack/react-router';
import { PassportScreen } from '@/features/passport/PassportScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';

export const Route = createFileRoute('/_app/profile/passport')({
  beforeLoad: requireAuth,
  component: PassportScreen,
});
